export default "__VITE_PUBLIC_ASSET__cec35997__"